module.exports = __webpack_public_path__ + "img/model-category.a411af56.svg";